<template>
	<div class="page">
		<div class="p16 flex-row">
			<div>
				<span class="cur" @click="backRouter"><i class="el-icon-arrow-left"></i>返回</span>
				<el-divider direction="vertical" class="color999"></el-divider>
				<span class="color999 cur" @click="back">会员管理&nbsp;/&nbsp;</span>
			</div>
			<div>会员资料</div>
		</div>
		<div class="mains-content">
			<div class="tops-title">
				<div class="top p10">
					<img v-if="memberInfo.headImgUrl" :src="memberInfo.headImgUrl" class="avatar" alt="ss" />
					<img v-else class="avatar" src="../../assets/images/headerImg.png" alt="aa" />
					<div class="infos">
						<div class="mb16">{{ memberInfo.realName == null ? '神秘会员' : memberInfo.realName }}</div>
						<div class="flex-row fontSize14">
							<div>{{ memberInfo.mobile ? memberInfo.mobile: memberInfo.idCardNo}}</div>
							<div class="item ml30">
								<span class="">会员来源：</span>
								<span class="">{{ memberInfo.shopName }}</span>
							</div>
							<div class="item ml30">
								<label class="label">注册时间：</label>
								<span>{{ formatDate(memberInfo.registerTime) }}</span>
							</div>
              <div class="item ml30">
								<label class="label">会员备注：</label>
								<span>{{ memberInfo.memberRemark || '暂无' }}</span>
							</div>
						</div>

					</div>
				</div>
				<div>
					<el-button size="mini" @click="editClick" v-perm="{key:'memberManager', value:'memberManager:update'}">修改资料</el-button>
					<el-button size="mini" @click="memberTopUp" v-perm="{key:'memberManager', value:'memberManager:recharge'}">会员充值</el-button>
					<el-button size="mini" @click="memberCancel" v-perm="{key:'memberManager', value:'memberManager:withdraw'}" v-if="memberInfo.showDestroyCarkFlag">会员销卡</el-button>
				</div>
			</div>
			<div class="align-items member_balance">
				<div class="flex-row ml16 w50s">
					<div>
						<div>账户余额(元)</div>
						<div class="fb f28 mt10">{{memberInfo.totalAmount}}</div>
					</div>
					<div class="member_integral">
						<div>可用积分</div>
						<div class="fb f28 mt10">{{ Math.floor(memberInfo.integralAmount) || 0 }}</div>
					</div>
				</div>
				<div class="align-items w50s mr50">
					<div>
						<div>可用余额(元)</div>
						<div class="fb f28 mt10">{{memberInfo.walletAmount}}</div>
					</div>
					<div>
						<div>账户本金(元)</div>
						<div class="fb f28 mt10">{{ memberInfo.baseAmount }}</div>
					</div>
					<div>
						<div>账户赠金(元)</div>
						<div class="fb f28 mt10">{{memberInfo.giveAmount}}</div>
					</div>
					<div>
						<div>冻结金额(元)</div>
						<div class="fb f28 mt10">{{ memberInfo.freezeAmount }}</div>
					</div>
				</div>
			</div>

			<div class="member-head moneys" v-if="memberInfo.accountStatus != 'enable'">
				<div class="member_bg">
					提示：{{memberInfo.remark}}
				</div>
			</div>
			<div class="member-content-box">
				<el-tabs class="tabs" v-model="activeName" type="border-card" @tab-click="tableChange">
					<el-tab-pane label="交易明细" name="waitConsume" header-cell-class-name="table_header_bgcolor" v-perm="{key:'memberManager', value:'memberManager:tradeDetail'}">
						<div class="member-header">
							<div class="flex-row space-between">
								<div class="flex-row">
									<el-select v-model="twoQuery.tradeType" class="mr10" placeholder="全部状态">
										<el-option label="全部交易类型" value></el-option>
										<el-option label="充值" value="recharge"></el-option>
										<el-option label="消费" value="consume"></el-option>
										<el-option label="提现" value="withdraw"></el-option>
										<el-option label="退款" value="refund"></el-option>
										<el-option label="冻结" value="freeze"></el-option>
										<el-option label="解冻" value="unfreeze"></el-option>
										<!-- <el-option label="订单作废" value="invalid"></el-option> -->
									</el-select>
									<el-select v-model="twoQuery.platformType" class="mr10" placeholder="全部状态"
										v-if="$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag">
										<el-option label="vip会员卡" value="ysk"></el-option>
										<el-option label="贵宾卡" value="yuanjian"></el-option>
									</el-select>
								</div>
								<v-notDate :beginTime="twoQuery.beginTime" :endTime="twoQuery.endTime"
									@time="changeDate" :clearable="false" class="mr10"></v-notDate>
							</div>
							<el-button type="primary" @click="searchDoQuery">搜索</el-button>
						</div>
						<div class="tables">
							<el-table :data="waitConsumeList" max-height="390px"
								header-cell-class-name="table_header_bgcolor" empty-text="暂无数据，重新筛选交易时间试试">
								<el-table-column prop="shopName" label="交易门店"></el-table-column>
								<el-table-column prop="tradeDetail" label="交易内容"></el-table-column>
								<el-table-column align="left" prop="tradeTypeCn" label="交易类型"
									width="100px"></el-table-column>
								<el-table-column align="left" prop="payCheckTypeCn" label="验证方式"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="payWayCn" label="支付方式"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="amount" label="交易金额"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="baseAmount" label="账户本金"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="giveAmount" label="账户赠金"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="leftAmount" label="交易后余额"
									width="120px"></el-table-column>
								<el-table-column align="left" prop="oxCname" label="操作人"
									width="120px"></el-table-column>
								<el-table-column align="left" label="交易时间" width="160px">
									<template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane label="档案管理" name="repair" header-cell-class-name="table_header_bgcolor"  v-perm="{key:'memberManager', value:'memberManager:repair'}">
						<div class="tables">
							<el-table :data="repairList" max-height="420px" >
								<el-table-column prop="shopName" label="建档门店" width="250px">
									<template slot-scope="scope">{{ scope.row.shopName }}</template>
								</el-table-column>
								<el-table-column align="center" label="部位" width="100px" prop="categoryName">
									<template slot-scope="scope">
										<span
											v-if="scope.row.leftAmount != 0 && scope.row.realPayAmount != 0">{{scope.row.categoryName}}<span
												class="jishi">(分期)</span></span>
										<span v-else>{{scope.row.categoryName}}</span>
									</template>
								</el-table-column>
								<el-table-column align="center" prop="amount" label="档案金额">
									<!-- <template slot-scope="scope">{{ scope.row.amount == 0? '***':scope.row.amount }}</template> -->
									<template slot-scope="scope">{{ scope.row.amount }}</template>
								</el-table-column>
								<el-table-column align="center" prop="staffName" label="建档技师" width="110px">
									<template slot-scope="scope">{{ scope.row.staffName }}</template>
								</el-table-column>
								<el-table-column align="center" label="档案状态" width="120px">
									<template slot-scope="scope">{{ scope.row.repairStatusCn }}</template>
								</el-table-column>
								<el-table-column align="center" label="下次登记时间" width="120px">
									<template
										slot-scope="scope">{{ scope.row.repairStatus == 'refund' || scope.row.repairStatus == 'finish' ? "" : formatDay(scope.row.nextRepairTime) }}</template>
								</el-table-column>
								<el-table-column align="center" prop="oxCtime" label="过期/完成时间">
									<template
										slot-scope="scope">{{scope.row.validDay==-1?'永久有效': scope.row.repairStatus == 'finish' ? formatDay(scope.row.oxLtime) : scope.row.repairStatus == 'build' || scope.row.repairStatus == 'refund'? "" : formatDay(scope.row.validEndTime)}}</template>
								</el-table-column>
								<el-table-column align="center" label="操作" width="120px">
									<template slot-scope="scope">
										<el-link type="primary" @click="detailsRepair(scope.row)">查看详情</el-link>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane label="会员数据" name="memberData" header-cell-class-name="table_header_bgcolor" v-perm="{key:'memberManager', value:'memberManager:data'}">
						<div class="tables">
							<el-table :data="memberDataList" max-height="420px">
								<el-table-column prop="rechargeNum" label="充值次数" width="150px">
									<template slot-scope="scope">{{ scope.row.rechargeNum }}</template>
								</el-table-column>
								<el-table-column align="center" prop="rechargeAmount" label="累计充值金额" width="150px">
									<template slot-scope="scope">{{ scope.row.rechargeAmount }}</template>
								</el-table-column>
								<el-table-column align="center" prop="consumeNum" label="消费次数" width="150px">
									<template slot-scope="scope">{{ scope.row.consumeNum }}</template>
								</el-table-column>
								<el-table-column align="center" label="累计消费金额" width="150px">
									<template slot-scope="scope">{{ scope.row.consumeAmount }}</template>
								</el-table-column>
								<el-table-column align="center" label="最近一次消费时间" width="auto">
									<template slot-scope="scope">{{ formatDate(scope.row.consumeLastDate) }}</template>
								</el-table-column>
								<el-table-column align="center" prop="oftenConsumeShopName" label="常去门店" width="180px">
									<template slot-scope="scope">{{ scope.row.oftenConsumeShopName }}</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>
					<el-tab-pane label="会员卡包" name="card" v-perm="{key:'memberManager', value:'memberManager:card'}">
						<div class="member-header">
							<div class="flex-row space-between">
								<div class="flex-row">
									<el-button-group>
										<el-button type="primary" plain @click="onConfirms(1)"
											v-if="cardIndex==1">会员卡</el-button>
										<el-button plain @click="onConfirms(1)" v-else>会员卡</el-button>
										<el-button type="primary" plain @click="onConfirms(2)"
											v-if="cardIndex==2">套餐卡</el-button>
										<el-button plain @click="onConfirms(2)" v-else>套餐卡</el-button>
										<el-button type="primary" plain @click="onConfirms(3)"
											v-if="cardIndex==3">优惠券</el-button>
										<el-button plain @click="onConfirms(3)" v-else>优惠券</el-button>
									</el-button-group>
								</div>
							</div>
						</div>
						<div class="tables">
							<el-table :data="cardList" max-height="390px" header-cell-class-name="table_header_bgcolor"
								v-if="cardIndex==3">
								<el-table-column prop="couponName" label="优惠券名称" width="200">
									<template slot-scope="scope">{{ scope.row.couponName }}</template>
								</el-table-column>
								<el-table-column prop="couponAmount" label="面值">
									<template slot-scope="scope">¥{{ scope.row.couponAmount }}</template>
								</el-table-column>
								<el-table-column prop="useLimitAmount" label="使用门槛">
									<template slot-scope="scope">满{{ scope.row.useLimitAmount }}元可用</template>
								</el-table-column>
								<el-table-column prop="originNum" label="失效时间" width="320">
									<!-- <template slot-scope="scope">{{ formatDate(scope.row.beginTime) }}-{{ formatDate(scope.row.endTime) }}</template> -->
									<template slot-scope="scope">{{ scope.row.validDateStr }}</template>
								</el-table-column>
								<el-table-column prop="statusEn" label="状态" width="100">
									<template slot-scope="scope">
										<span v-if="scope.row.statusEn == 'nouse'" class="orange">待使用</span>
										<span v-else-if="scope.row.statusEn == 'use'" class="color111">已使用</span>
										<span v-else class="red">已失效</span>
									</template>
								</el-table-column>
								<el-table-column label="卡券详情" width="100px">
									<template slot-scope="scope">
										<el-link type="primary" @click="couponDetails(scope.row)">查看</el-link>
									</template>
								</el-table-column>
							</el-table>
							<el-table :data="cardList" max-height="378px" header-cell-class-name="table_header_bgcolor"
								v-else>
								<el-table-column prop="cardName" label="卡项名称">
									<template slot-scope="scope">{{ scope.row.cardName }}</template>
								</el-table-column>
								<el-table-column prop="cardName" label="卡项类型">
									<template slot-scope="scope">{{ scope.row.cardTypeCn }}</template>
								</el-table-column>
								<el-table-column prop="shopName" label="开卡门店" width="280">
									<template slot-scope="scope">{{ scope.row.shopName }}</template>
								</el-table-column>
								<!-- <el-table-column prop="shopName" label="开卡门店"  width="280"></el-table-column> -->
								<el-table-column prop="originNum" label="有效时间/次数" width="120">
									<template slot-scope="scope">
										<span
											v-if="scope.row.cardType == 'discount'">{{ scope.row.validDay == -1 ? '永久有效' : scope.row.validDay + '天'}}</span>
										<span v-else>{{ scope.row.originNum + '次'}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="leftCount" label="剩余" width="120">
									<template slot-scope="scope">
										<span v-if="scope.row.cardType == 'discount'"></span>
										<span
											v-else-if="scope.row.cardType != 'discount'">{{scope.row.leftCount + '次'}}</span>
									</template>
								</el-table-column>
								<el-table-column prop="status" label="状态" width="80">
									<template slot-scope="scope">
                    <span v-if="scope.row.cardType == 'discount' && scope.row.status == 'disable'">{{ '已失效' }}</span>
                    <span v-else-if="scope.row.cardType != 'discount' && (scope.row.leftCount == 0 || scope.row.status == 'disable')">{{ '已失效' }}</span>
                    <span v-else>{{ scope.row.statusCn }}</span>
                  </template>
								</el-table-column>
								<el-table-column prop="validEndTime" label="开卡日期" width="100">
									<template slot-scope="scope">{{ formatDay(scope.row.oxCtime) }}</template>
								</el-table-column>
								<el-table-column prop="validEndTime" label="失效日期" width="100">
									<template
										slot-scope="scope">{{ scope.row.validDay == -1 ? '永久有效' : formatDay(scope.row.validEndTime) }}</template>
								</el-table-column>
								<el-table-column label="操作" width="100px">
									<template slot-scope="scope">
										<el-link type="primary" v-if="scope.row.cardType == 'discount'"
											@click="cardDetails(scope.row)">详情</el-link>
										<el-link type="primary" v-if="scope.row.cardType != 'discount'"
											@click="cardPage(scope.row)">划卡记录</el-link>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>

					<el-tab-pane label="积分账户" name="integralRecord" header-cell-class-name="table_header_bgcolor" v-perm="{key:'memberManager', value:'memberManager:integral'}">
						<div class="member-header">
							<div class="flex-row space-between">
								<div class="flex-row">
									<el-select v-model="fourQuery.tradeDirection" class="mr10" placeholder="类型"
										filterable>
										<el-option label="全部" value></el-option>
										<el-option label="收入" value="in"></el-option>
										<el-option label="支出" value="out"></el-option>
									</el-select>
								</div>
								<v-date @time="changeDates" class="mr10"></v-date>
							</div>
							<el-button type="primary" class="" @click="integralDoQuery">搜索</el-button>
						</div>
						<div class="tables">
							<el-table :data="integralList" max-height="390px"
								header-cell-class-name="table_header_bgcolor">
								<el-table-column prop="shopName" label="门店名称" width="280"></el-table-column>
								<el-table-column prop="tradeDirectionCn" width="auto" label="类型"></el-table-column>
								<el-table-column prop="amount" label="积分" width="auto"></el-table-column>
								<el-table-column prop="remark" label="备注" width="auto"></el-table-column>
								<el-table-column prop="oxCtime" label="操作时间" width="auto">
									<template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
								</el-table-column>
								<el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
									<template slot-scope="scope">
										<el-link type="primary" @click="details(scope.row)">详情</el-link>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-tab-pane>

				</el-tabs>
				<paging :currentPage="currentPage" :pageSize="pageSize" :totalCount="totalCount" @doPageQuery="doPage"
					v-if="activeName!='memberData'"></paging>
			</div>
		</div>
		<!-- <edit-set ref="editSetForm" @change="editChange"></edit-set> -->
		<detail-set ref="detailSetForm"></detail-set>
		<card-set ref="cardSetForm"></card-set>
		<update-pwd ref="updatePwdSetForm"></update-pwd>
		<repair-detail ref="detailEditForm" @change="repairDetail"></repair-detail>
		<repair-details ref="detailForm" @change="repairDetail"></repair-details>
		<member-top-up ref="memberTopUpForm" @memberChange="changeTopUp"></member-top-up>
		<member-cancel-card ref="memberCancelCardForm" @handleChangeCard="changeTopUp"></member-cancel-card>
		<card-detail ref="cardDetailForm" @change="cardBack"></card-detail>
		<integral-detail ref="integralForm"></integral-detail>
		<editMember ref="editForm" @change="memberBack"></editMember>
		<couponDetail-set ref="couponDetailForm" @change="couponDetailBack"></couponDetail-set>
	</div>
</template>

<script>
	import minxin from "../../assets/javascript/minxin.js";
	// import editSet from "./edit";
	import cardSet from "./card";
	import repairDetail from "../collectMoney/paperRepair/handle";
	import repairDetails from "../collectMoney/paperRepair/repairCheckIn";
	import detailSet from "./detail";
	import updatePwd from "./updatePwd";
	import memberTopUp from "../collectMoney/member/topUp";
	import memberCancelCard from "../collectMoney/member/cancelCard";
	import cardDetail from "./cardDetail.vue";
	import integralDetail from "./integralDetail";
	import editMember from "./updateMember";
	import couponDetailSet from "./couponDetail.vue";
	export default {
		mixins: [minxin],
		data() {
			return {
				pageHeight: this.$store.getters.MainHeight,
				list: [],
				cardList: [],
				waitConsumeList: [],
				repairList: [],
				integralList: [],
				memberDataList: [],
				activeName: "waitConsume",
				cardIndex: 1,
				totalCount: 0,
				// url: this.$url.member.list,
				query: {
					memberId: this.$route.params.id,
					size: 100,
					start: 1,
					cardType: "discount", //会员卡discount、套餐卡othercard
					status: "",
				},
				twoQuery: {
					memberId: this.$route.params.id,
          tradeType: "", //recharge
          tradeTypes: [],
					beginTime: "",
					endTime: "",
					platformType: this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag ? 'ysk' : '',
					size: 20,
					start: 1
				},
				threeQuery: {
					memberId: this.$route.params.id,
					staffId: "",
					searchShopId: "",
					status: "",
					size: 20,
					start: 1
				},
				fourQuery: {
					beginTime: "",
					endTime: "",
					start: 0,
					size: 20,
					memberId: this.$route.params.id,
					tradeDirection: ""
				},
				memberDataQuery: {
					memberId: this.$route.params.id
				},
				tab: 'waitConsume',
				currentPage: 1,
				pageSize: 0,
				memberInfo: {},
			};
		},
		components: {
			// editSet,
			cardSet,
			detailSet,
			repairDetail,
			repairDetails,
			updatePwd,
			memberTopUp,
			memberCancelCard,
			cardDetail,
			integralDetail,
			editMember,
			couponDetailSet,
		},
		watch: {
			repairList(o) {
        let appInfo = this.$store.getters.ShopInfo;
				o.map(item => {
					if (appInfo.shopId != item.shopId) item.amount = "***";
				})
			}
		},
		created() {
			// this.getList();
      if (this.$route.query.item) {
        let {beginTime, endTime, tradeTypes } = JSON.parse(this.$route.query.item)
        console.log(this.$route.query);
        this.twoQuery.beginTime = beginTime
        this.twoQuery.endTime = endTime
        this.twoQuery.tradeTypes = tradeTypes
      } else {
        this.twoQuery.beginTime = this.formatMonth(new Date()) + '-01';
        this.twoQuery.endTime = this.formatDay(new Date());
      }
      
			this.init();

		},
  methods: {
    backRouter () {
      if (Object.keys(this.twoQuery.tradeTypes).length != 0) {
        localStorage.setItem("setCurentUrl", 'dataList/memberDataAnalysis');
        this.$router.push('/dataList/memberDataAnalysis')
      } else {
        this.$router.push("/member");
      }
    },
			back() {
				this.$router.push("/member");
			},
			tableChange(val) {
				this.cardList = [];
				this.cardIndex = 1;
				this.currentPage = 1;
				this.query.start = 1;
				this.twoQuery.start = 1;
				this.threeQuery.start = 1;
				// this.activeName = val.name;
				this.tab = val.name;
				this.pageSize = "";
				if (val.name == "card") {
					if (this.cardIndex == 3) {
						this.pageSize = 0;
						this.query.size = 20;
          } else {
            this.query.cardType = "discount";
						this.pageSize = 100;
						this.query.size = 100;
					}
					this.memberList();
				}
				if (val.name == "waitConsume") {
					this.consumer();
				}
				if (val.name === "repair") {
					this.xhjlList();
				}
				if (val.name == "integralRecord") {
					this.getIntegralCount();
				}
				if (val.name == "memberData") {
					this.getMemberData();
				}
			},
			editClick() {
				this.$refs["editForm"].$emit("set", this.memberInfo);
			},
			doPage(val) {
				if (this.tab == "card") {
					this.query = Object.assign(this.query, val)
					this.memberList();
				}
				if (this.tab == "waitConsume") {
					this.twoQuery = Object.assign(this.twoQuery, val);
					this.consumer();
				}
				if (this.tab == "repair") {
					this.threeQuery = Object.assign(this.threeQuery, val)
					this.xhjlList();
				}
				if (this.tab == "integralRecord") {
					this.fourQuery = Object.assign(this.fourQuery, val)
					this.getIntegralCount();
				}
			},
			onConfirms(index) {
				if (index == 1) {
					this.query.cardType = "discount";
					this.query.size = 100;
					this.pageSize = 100;
				} else if (index == 2) {
					this.query.cardType = "othercard";
					this.query.size = 100;
					this.pageSize = 100;
				} else {
					this.query.cardType = "";
					this.query.size = 20;
					this.pageSize = 0;
				}
				this.cardIndex = index;
				this.memberList();
			},
			memberList() {
				if (this.cardIndex == 3) {

					this.getmemberCount();
					this.$api.post(this.$url.member.couponSendRecordList, this.query).then(res => {
						if (res) {
							this.cardList = res;
						}
					}).catch(error => {})
				} else {
					this.$api.get(this.$url.member.list, this.query).then(res => {
						if (res) {
							this.cardList = res;
							this.totalCount = res.totalCount ? res.totalCount : res.length || 0
						}
					})
				}
			},
			getmemberCount() { // 卡券多少个
				this.$api.post(this.$url.member.couponSendRecordCount, this.query).then(res => {
					this.totalCount = res;
				}).catch(error => {});
			},
			getIntegralCount() { // 积分账户
				this.$api.post(this.$url.integralItem.integralCount, this.fourQuery).then(res => {
					this.totalCount = res;
					this.getIntegral();
				}).catch(error => {});
			},
			getIntegral() { // 积分账户
				this.$api.post(this.$url.integralItem.integralList, this.fourQuery).then(res => {
					if (res) {
						this.integralList = res;
					}
				}).catch(error => {});
			},
			getMemberData() {
				this.$api.get(this.$url.memberAccount.get, this.memberDataQuery).then(res => {
					if (res) {
						this.memberDataList = [];
						this.memberDataList.push(res);
					}
				})
			},
			memberTopUp() {
				// 会员充值
				this.$refs["memberTopUpForm"].$emit("set", this.query.memberId);
			},
			memberCancel() {
				// 会员撤销
				this.$refs["memberCancelCardForm"].$emit("set", this.memberInfo.mobile ? this.memberInfo.mobile : this
					.memberInfo.idCardNo);
			},
			changeTopUp(org) {
				// 会员充值  -  回调
				if (org) {
					this.init();
				}
			},
			integralDoQuery() {
				this.fourQuery.start = 0;
				this.getIntegralCount();
			},
			searchDoQuery() {
				console.log(this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag);
				this.twoQuery = {
					memberId: this.$route.params.id,
					tradeType: this.twoQuery.tradeType, //recharge
					beginTime: this.twoQuery.beginTime,
					endTime: this.twoQuery.endTime,
					platformType: this.$store.getters.ShopInfo.shopBizConfig.yuanyuanFlag ? this.twoQuery
						.platformType : '',
					size: 20,
					start: 1
				};
				this.consumer();
			},
			changeDate(value) {
				this.twoQuery.beginTime = value[0] ? this.formatDay(value[0]) : this.formatMonth(new Date()) + '-01';
				this.twoQuery.endTime = value[1] ? this.formatDay(value[1]) : this.formatDay(new Date());
			},
			changeDates(value) {
				this.fourQuery.beginTime = value[0] ? this.formatDay(value[0]) : '';
				this.fourQuery.endTime = value[1] ? this.formatDay(value[1]) : '';
			},
			init() {
				this.cardList = [];
				this.consumer();

				this.$api.get(this.$url.member.get, {
					id: this.query.memberId
				}).then(res => {
					if (res) {
						this.memberInfo = res;

					}
				})
			},
			memberBack() {
				this.$api.get(this.$url.member.get, {
					id: this.query.memberId
				}).then(res => {
					if (res) {
						this.memberInfo = res;
					}
				})
			},
			repairDetail(org) {
				if (org) this.xhjlList()
			},
			consumer() {
				console.log(this.twoQuery)
				this.waitConsumeList = [];
				this.totalCountes();
				this.$api
					.post(this.$url.memberFundFlow.listByMember, this.twoQuery)
					.then(res => {
						if (res) {
							this.waitConsumeList = res;
						}
					})
					.catch(error => {});
			},
			totalCountes() {
				this.$api.post(this.$url.memberFundFlow.listCount, this.twoQuery).then(res => {
					this.totalCount = res;
				}).catch(error => {});
			},
			xhjlList() {
				this.repairList = [];
				this.totalCounts();
				this.$api.post(this.$url.repairDocument.list, this.threeQuery).then(res => {
						if (res) {
							this.repairList = res;
						}
					})
					.catch(error => {});
			},
			totalCounts() {
				this.$api.post(this.$url.repairDocument.count, this.threeQuery).then(res => {
					this.totalCount = res;
				}).catch(error => {});
			},
			editChange(bool) {
				if (bool) {
					this.query = {
						mobile: "",
						start: 1,
						size: 20
					};
					this.getList();
				}
			},
			detailPage(item) {
				this.$router.push(`/manage/memberDetail/${item.id}`);
				//   this.$refs["detailSetForm"].$emit("set", item);
			},

			updatePage(item) {
				this.$refs["updatePwdSetForm"].$emit("set", item);
			},
			repairDocumentPage(item) {
				this.$router.push({
					path: "/paperRepair/edit",
					query: {
						mobile: item.mobile
					}
				});
			},
			cardPage(item) {
				this.$refs["cardSetForm"].$emit("set", item);
			},
			detailsRepair(row) {
				console.log(row.repairStatus == 'build' || row.repairStatus != 'refund', "row")
				if (row.repairStatus == 'build' || row.repairStatus == 'refund') {
					this.$refs["detailForm"].$emit("set", row);

				} else {
					this.$refs["detailEditForm"].$emit("set", row);
				}

			},

			cashierWaitConsume(row) {
				this.$refs["editForm"].$emit("set", row.id);
			},
			orderInfoPage(item) {
				this.$router.push({
					name: "/orderInfo",
					params: {
						item: {
							orderStatus: "waitExtract",
							customerName: item.mobile
						}
					}
				});
			},
			cardDetails(row) {
				// 折扣卡详情
				this.$refs["cardDetailForm"].$emit("set", row);
			},
			cardBack(org) {
				if (org) {
					this.memberList();
				}
			},
			couponDetails(row) {
				// 卡券详情
				this.$refs["couponDetailForm"].$emit("set", row);
			},
			couponDetailBack(org) {
				if (org) {
					this.memberList();
				}
			},
			details(row) {
				if (row.id) {
					this.$refs["integralForm"].$emit("set", row.id);
				}
			},
		}
	};
</script>

<style scoped lang="less">
	@import "../../assets/css/edit.less";

	.member-head {
		background: #fff;
		margin-top: 10px;
		padding: 10px 20px;

		.member_bg {

			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
	}

	.mains-content {
		height: 100%;
		margin: 16px;

		.tops-title {
			background: #092B5B;
			width: 100%;
			padding: 0 16px;
			box-sizing: border-box;
			height: 78px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			color: #fff;
			border-radius: 10px 10px 0 0;
		}

		.member-content-box {
			margin-top: 10px;
			background: #fff;
			height: calc(100% - 63px);
			padding: 16px 16px 0;
			border-radius: 10px;
		}
	}

	.mains-bottom {
		.back {
			position: absolute;
			left: 26px;
		}

		width: calc(100% - 30px);
		position: absolute;
		background-color: #fff;
		height: 62px;
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		bottom: 15px;
	}

	.member-header {
		background: #fff;
		height: 56px;
		display: flex;
		align-items: center;
		border-bottom: 2px solid @borderColor;

		.setDate {
			margin-right: 15px;

			.date-inputs {
				width: 150px;
				height: 32px;

				/deep/.el-input__inner {
					width: 150px;
					height: 32px;
				}

				/deep/ .el-input__prefix {
					top: -3px;
				}
			}
		}

		.top-label {
			width: 90px;
		}
	}

	.top {
		display: flex;
		align-items: center;

		img {
			width: 45px;
			height: 45px;
			border-radius: 50%;
			margin-right: 16px;
		}

		.scrm-profile {
			padding-top: 5px;
			display: flex;

			.item {
				display: flex;
				margin: 4px 0;
				padding: 0 20px;
				border-right: 1px solid #eee;

				.label {
					display: inline-block;
					color: #969799;
				}

				&:first-child {
					padding-left: 0;
				}

				&:last-child {
					border-right: 0 none;
				}
			}
		}
	}

	.member_balance {
		height: 100px;
		background: #fff;
		font-size: 14px;
		border-radius: 0 0 10px 10px;
		text-align: center;
		color: #333;

		.member_integral {
			margin-left: 100px;
			padding-left: 10px;
			border-left: 1px solid #e7e7e7;
		}
	}

	.el-button--primary.is-plain {
		background: #EDF4FF;
		color: #409eff;
		border-color: #409eff;
	}
</style>